import { fromJS } from 'immutable';
import { ReportAction, ReportActionTypes as actionTypes } from './reportTypes';

const initialState = fromJS({
	getReportsData: {},
	getReportsStatus: 'neutral',
	isLoading: false
});

export default (state = initialState, action: ReportAction) => {
	switch (action.type) {
		case actionTypes.REPORT_GET_REPORTS_REQUEST:
			return state.set('isLoading', true);
		case actionTypes.REPORT_GET_REPORTS_SUCCESS:
			return action.payload
				? state
						.set('getReportsData', fromJS(action.payload))
						.set('isLoading', false)
				: state
						.set('isLoading', false)
						.set('getReportsStatus', 'success');
		case actionTypes.REPORT_GET_REPORTS_FAILURE:
			return state
				.set('isLoading', false)
				.set('getReportsStatus', 'failure');
		case actionTypes.REPORT_GET_REPORTS_CLEAR_STATE:
			return state.set('getReportsStatus', 'neutral');
		case actionTypes.REPORT_ADD_REQUEST:
		case actionTypes.REPORT_ADD_SUCCESS:
		case actionTypes.REPORT_ADD_FAILURE:
		default:
			return state;
	}
};
